// src/components/ProductCard.js (adjust path as needed)
import React from 'react';

import { useTheme } from '@mui/material/styles';
import { Card } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import { CardFolderContent } from 'common/components/cards';
import ReactHookFormCheck from 'common/components/form/ReactHookFormCheck';

import folderImage from 'resources/folder.svg';

const ProductCard = ({ control, name, product }) => {
    const theme = useTheme();
    const { id, name: productName } = product;

    const sx = {
        color:
            theme.palette.mode === 'dark'
                ? '#fff'
                : theme.palette.primary.contrastText,
    };

    const title = (
        <ReactHookFormCheck
            control={control}
            label={productName}
            name={`${name}.${id}`} // e.g., "financiers_products.productId"
            sxFormLabel={sx}
        />
    );

    return (
        <label>
            <Card>
                <CardFolderContent image={folderImage} title={title} />
            </Card>
        </label>
    );
};

ProductCard.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    product: PropTypes.object.isRequired,
};

export default ProductCard;
